import(/* webpackMode: "eager" */ "/home/ubuntu/roffice-github-frontend/frontend/src/app/auth/forgot-password/page.tsx");
